<script setup lang="ts">
import { RouterLink } from 'vue-router'

import { legalLinks } from '@/data/legal'

const links = [
  { to: legalLinks.terms, label: 'Terms of Service' },
  { to: legalLinks.privacy, label: 'Privacy Policy' },
  { to: legalLinks.acceptableUse, label: 'AI Acceptable Use Policy' },
] as const
</script>

<template>
  <footer class="app-footer">
    <nav
      class="app-footer__links"
      aria-label="Legal"
    >
      <RouterLink
        v-for="link in links"
        :key="link.to"
        :to="link.to"
      >
        {{ link.label }}
      </RouterLink>
    </nav>
    <p>© UIG</p>
  </footer>
</template>

<style scoped>
.app-footer {
  display: flex;
  width: min(100%, 1050px);
  margin: 0 auto;
  padding: 20px 16px 24px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 24px;
  border-top: .5px solid var(--divider);
  color: var(--text-secondary);
  font-size: .82rem;
  line-height: 1.4;
}

.app-footer__links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
}

.app-footer a {
  color: var(--text-secondary);
  text-decoration: none;
}

.app-footer a:hover,
.app-footer a.router-link-active {
  color: var(--text);
}
</style>
